export default "__VITE_ASSET__176b48e8__"